import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  question: "I'm so busy, how much time does this take?",
  answer: 'Exactly 10 minutes a day. It\'s designed for women who have zero "extra" time.'
}, {
  question: 'Do I need to buy expensive supplements?',
  answer: 'No. We show you what works, but the core protocol uses food, light, and movement you already have.'
}, {
  question: 'Is this just another diet?',
  answer: 'Absolutely not. There is no calorie counting. This is about Biological Signaling.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-cream-dark" data-id="element-17">
      <div className="max-w-3xl mx-auto" data-id="element-18">
        <div className="text-center mb-12" data-id="element-19">
          <h2 className="text-3xl sm:text-4xl font-display font-bold text-charcoal-800 mb-4" data-id="element-20">
            Frequently Asked Questions
          </h2>
        </div>

        <div className="space-y-4" data-id="element-21">
          {faqs.map((faq, index) => <div key={index} className="bg-white rounded-2xl overflow-hidden shadow-sm border border-cream transition-colors hover:border-sage-400/30" data-id="element-22">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none focus-visible:ring-2 focus-visible:ring-sage-400 focus-visible:ring-inset" aria-expanded={openIndex === index} data-id="element-23">
                <span className="font-bold text-lg text-charcoal-800" data-id="element-24">
                  {faq.question}
                </span>
                <ChevronDown className={`w-5 h-5 text-sage-500 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-25" />
              </button>

              <AnimatePresence data-id="element-26">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-27">
                    <div className="px-6 pb-5 pt-0 text-charcoal-700/80 leading-relaxed" data-id="element-28">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}